/* eslint-disable import/prefer-default-export */
// ADM, KTT, KTV của F1 được reset balance agency
export const TYPE_CAN_RESET_BALANCE_AGENCY = ['ADM', 'OPE', 'KTT', 'KTV', 'SE']
